import { useUserStore } from '@/stores/user.store'
import { useAppStore } from '@/stores/app.store'

export default class Store {
  userStore = useUserStore()
  appStore = useAppStore()
}
